import React from 'react';
import DefaultCardKycButtonGroup from 'Components/shared/cards/DefaultCardKycButtonGroup';
import { i18nextKeys } from 'Lang/i18nextKeys';
import CustomButton from 'Features/Purchase/AssetCard/CustomButton';

const InvestmentCardButtons = ({
  topButtonAction = () => {},
  bottomButtonAction = () => {},
  bottomButtonDisabled = false,
  bottomButtonHidden = false,
  kycTier,
}) => (
  <DefaultCardKycButtonGroup
    buttonConfig={{
      topButton: {
        show: true,
        label: {
          insufficientTier: i18nextKeys.buttonMoreDetails,
          sufficientTier: i18nextKeys.buttonMoreDetails
        },
        onClick: topButtonAction
      },
      bottomButton: {
        show: !bottomButtonHidden,
        disabled: bottomButtonDisabled,
        label: {
          insufficientTier: i18nextKeys.kycGetTierToBuy,
          sufficientTier: i18nextKeys.customInvestmentsAssetActionButton
        },
        onClick: bottomButtonAction,
        origin: "asset tile"
      }
    }}
    requiredTier={kycTier}
    ButtonComponent={CustomButton}
    style={{
      gap: "10px",
      paddingLeft: "16px",
      paddingRight: "16px"
    }}
  />
);

export default InvestmentCardButtons;
